<template>
	<v-dialog
		v-model="showDialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">製品別撮影写真一覧</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-row justify="end" no-gutters>
					<PhotoNewDialog v-if="authority_flag" :id="id" @create-photo="createPhoto($event)" />
					<AllPhotoIndexDialog
						v-if="photos.length"
						:photos="photos"
						:order_individual_info_id="id"
						:authority_flag="authority_flag"
						@delete-photo="deletePhoto($event)"
						@update-photo="updatePhoto($event)"
					/>
				</v-row>
				<table width="100%" class="mt-4 show-dialog-table">
					<tbody>
						<ShowDetailRecord :columnName="'製造番号'">
							<template v-slot:value>
								<a @click="openOrderIndividualInfoDialog(order_individual_info)">
									{{ common.productNumberByOrderIndividualInfo(order_individual_info) }}
								</a>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord
							:columnName="'製品名'"
							:value="common.productNameWithSubName(order_individual_info.ordered_product)"
						/>
						<ShowDetailRecord :columnName="'数量'" :value="order_individual_info.quantity" />
					</tbody>
				</table>
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<tr>
							<th class="font-weight-bold" width="100%">撮影写真一覧</th>
						</tr>
						<tr>
							<td width="100%">
								<template v-if="activePhotos.length">
									<a
										v-for="photo in activePhotos"
										:key="photo.id"
										class="d-flex"
										@click="openShowDialog(photo)"
									>
										{{ photo.name }}
									</a> </template
								><template v-else>
									<p>撮影写真がありません。</p>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</v-sheet>
		</v-card>
		<PhotoShowDialog
			:dialog.sync="photoShowDialog"
			:photo="selectedPhoto"
			:authority_flag="authority_flag"
			:order_individual_info_id="id"
			@delete-photo="deletePhoto($event)"
			@update-photo="updatePhoto($event)"
		/>
		<OrderIndividualInfoShowDialog :dialog.sync="infoDialog" :id="selectedInfoId" />
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import AllPhotoIndexDialog from "./AllPhotoIndexDialog.vue"
import PhotoShowDialog from "./PhotoShowDialog.vue"
import PhotoNewDialog from "./PhotoNewDialog.vue"
import OrderIndividualInfoShowDialog from "../../order_individual_info/components/OrderIndividualInfoShowDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: null,
			required: false,
		},
		authority_flag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		AllPhotoIndexDialog,
		PhotoShowDialog,
		PhotoNewDialog,
		OrderIndividualInfoShowDialog,
	},
	data() {
		return {
			order_individual_info: {
				ordered_product: {
					product: {},
				},
			},
			photos: [],
			selectedPhoto: {
				id: null,
				name: null,
				created_at: null,
				user: {
					full_name: null,
				},
			},
			photoShowDialog: false,
			infoDialog: false,
			common,
			selectedInfoId: null,
		}
	},
	methods: {
		openDialog() {
			this.showDialog = true
		},
		fetchPhotos() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/order_individual_infos/${this.id}/photos`
			axios
				.get(url, { headers })
				.then((res) => {
					this.order_individual_info = res.data.order_individual_info
					this.photos = res.data.photos
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updatePhoto(photo) {
			const found_photo = this.photos.find((item) => {
				return item.id == photo.attached_file_id
			})
			if (found_photo) found_photo.name = photo.data.name
			this.$emit("update-photo", photo)
		},
		deletePhoto(photo) {
			let index = this.photos.findIndex((item) => item.id == photo.attached_file_id)
			if (index !== -1) {
				this.photos.splice(index, 1, photo.data)
				this.$emit("delete-photo", photo)
			}
		},

		createPhoto(photo) {
			this.photos.push(photo.data)
			this.$emit("create-photo", photo)
		},
		openShowDialog(photo) {
			this.selectedPhoto = photo
			this.photoShowDialog = true
		},
		openOrderIndividualInfoDialog(order_individual_info) {
			this.selectedInfoId = order_individual_info.id
			this.infoDialog = true
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		activePhotos() {
			return this.photos.filter((photo) => !photo.destroy_flag)
		},
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchPhotos(newVal)
		},
		deep: true,
	},
}
</script>
